export const environment = {
  production: false,
  version: '1.1.37',
  title: 'Optagestion',
  baseApiSysOpt: 'http://localhost:4200/api/optica',
};